var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TinyMceEditor',{attrs:{"id":"input-editor","value":_vm.value,"init":_vm.options},on:{"input":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }